export const FETCH_EVENTS = "FETCH_EVENTS";
export const FETCH_EVENT = "FETCH_EVENT";
export const FETCH_PAID_TICKETS = "FETCH_PAID_TICKETS";
